<template>
  <div class="member-detail-page">
    <div class="detail-hero">
      <button class="hero-btn hero-btn-left" @click="onClickLeft">
        <van-icon name="arrow-left" />
      </button>
      <van-swipe @change="swipeOnChange" :autoplay="3000" class="hero-swipe">
        <van-swipe-item v-for="(img, index) in memberInfos.personalPhotos" :key="index" @click="previewPhoto(index)">
          <van-image width="100%" height="100%" lazy-load :src="img.url" alt="" />
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">{{ current + 1 }}/{{ memberInfos.personalPhotos.length }}</div>
        </template>
      </van-swipe>
    </div>

    <div class="detail-main">
      <div class="detail-card profile-card">
        <div class="avatar-box" @click="previewAvatar">
          <van-image lazy-load :src="memberInfos.avatarLink || defaultPhoto" alt="" />
        </div>
        <div class="gender-badge">
          <img :src="memberInfos.sex === 1 ? manPhoto : womanPhoto" alt="">
        </div>
        <div class="profile-name-row">
          <span class="profile-name">{{ memberInfos.nickName || formatSerial(memberInfos.serialNumber) || '会员' }}</span>
          <span class="profile-tag">ID:{{ formatSerial(memberInfos.serialNumber) }}</span>
        </div>
          <div class="profile-summary" v-if="memberInfos.aiSummary">
            <span class="ai-badge">AI</span>
            <span class="summary-text">{{ memberInfos.aiSummary }}</span>
          </div>
        <div class="profile-meta">
          <!-- 交友宣言已移至底部独立模块 -->
          <!-- <span class="meta-chip">{{ sexText || '未填写性别' }}</span>
          <span class="meta-chip">{{ getFormatTime(memberInfos.birthday) || '未填写生日' }}</span>
          <span class="meta-chip">{{ memberInfos.hometown || '未填写籍贯' }}</span> -->
        </div>
      </div>

      <div class="detail-card info-card">
        <div class="section-title">基础信息</div>
        <div class="info-grid">
          <div class="info-cell"><span class="cell-label">籍贯</span><span class="cell-value">{{ memberInfos.hometown ||
            '未填写籍贯' }}</span></div>
          <!-- <div class="info-cell"><span class="cell-label">会员编号</span><span class="cell-value">ID:{{ formatSerial(memberInfos.serialNumber) }}</span></div> -->
          <div class="info-cell"><span class="cell-label">出生年月</span><span class="cell-value">{{
            getFormatTime(memberInfos.birthday) || '--' }}</span></div>
          <div class="info-cell"><span class="cell-label">身高</span><span class="cell-value">{{ memberInfos.height ?
            memberInfos.height + 'CM' : '--' }}</span></div>
          <div class="info-cell"><span class="cell-label">体重</span><span class="cell-value">{{ memberInfos.weight ?
            memberInfos.weight + 'KG' : '--' }}</span></div>
          <div class="info-cell"><span class="cell-label">学历</span><span class="cell-value">{{ educationText || '--'
              }}</span></div>
          <div class="info-cell" v-if="role != 'Matchmaker'"><span class="cell-label">毕业院校</span><span class="cell-value">{{
            memberInfos.graduateSchool || '--' }}</span></div>
          <div class="info-cell" v-if="role != 'Member'"><span class="cell-label">员工子组</span><span class="cell-value">{{
            memberInfos.employeeSubGroup || '--' }}</span></div>
          <!-- <div class="info-cell" v-if="memberInfos.datingDeclaration"><span class="cell-label">交友宣言</span><span
              class="cell-value">{{ memberInfos.datingDeclaration }}</span></div> -->
        </div>
      </div>

      <div class="detail-card info-card more-info-card" v-if="role == 'Matchmaker'">
        <div class="section-title collapsible-header" @click="showMoreInfo = !showMoreInfo">
          <span>更多信息</span>
          <van-icon :name="showMoreInfo ? 'arrow-up' : 'arrow-down'" />
        </div>
        <div v-show="showMoreInfo">
          <div class="desc-block">
            <!-- <div class="desc-title">家庭背景</div> -->
            <div class="info-grid">
              <div class="info-cell"><span class="cell-label">婚姻状态</span><span class="cell-value">{{ maritalStatusText
                ||
                '--' }}</span></div>
              <div class="info-cell"><span class="cell-label">期望结婚时间</span><span class="cell-value">{{ expectedMarriageDateText }}</span></div>
              <div class="info-cell"><span class="cell-label">个人信仰</span><span class="cell-value">{{ beliefsText || '--'
              }}</span></div>
              <div class="info-cell"><span class="cell-label">民族</span><span class="cell-value">{{ memberInfos.nation ||
                '--' }}</span></div>
              <div class="info-cell"><span class="cell-label">家庭成员</span><span class="cell-value">{{
                memberInfos.personalFamilyDescription || '--' }}</span></div>
            </div>
          </div>
          <div class="desc-block">
            <!-- <div class="desc-title">综合实力</div> -->
            <div class="info-grid">
              <div class="info-cell"><span class="cell-label">工作单位</span><span class="cell-value">{{
                memberInfos.companyName
                || '--' }}</span></div>
              <div class="info-cell"><span class="cell-label">岗位名称</span><span class="cell-value">{{
                memberInfos.positionTitle || '--' }}</span></div>
              <div class="info-cell"><span class="cell-label">毕业院校</span><span class="cell-value">{{
                memberInfos.graduateSchool || '--' }}</span></div>
              <div class="info-cell"><span class="cell-label">住房情况</span><span class="cell-value">{{ housingText || '--'
              }}</span></div>
            </div>
          </div>
          <div class="desc-block">
            <!-- <div class="desc-title">联系方式</div> -->
            <div class="info-grid">
              <div class="info-cell"><span class="cell-label">联系电话</span><span class="cell-value">{{
                memberInfos.contactNumber || '--' }}</span></div>
              <div class="info-cell"><span class="cell-label">入会推荐人</span><span class="cell-value">{{
                memberInfos.referrer
                || '--' }}</span></div>
            </div>
          </div>
        </div>
      </div>

      <div class="detail-card info-card">
        <div class="section-title">兴趣爱好</div>

        <div class="desc-block">
          <!-- <div class="desc-title">兴趣爱好</div> -->
          <div class="tag-wrap" v-if="interestTexts.length">
            <span v-for="(text, index) in interestTexts" :key="'i-' + index" class="tag-chip gray">{{ text }}</span>
          </div>
          <div class="desc-text" v-else>暂无填写</div>
        </div>
      </div>


      <!-- <div class="detail-card dashboard-card"
        v-if="role == 'Matchmaker' && relationInfo && (relationInfo.followUpMatchmaker || relationInfo.myRecommendedTarget)">
        <div class="section-title">跟进关联</div>

        <div class="relation-info-block" v-if="relationInfo.followUpMatchmaker">
          <div class="relation-info-label">跟进红娘</div>
          <div class="relation-info-value">
            <span class="member-tag">{{ relationInfo.followUpMatchmaker.name }}</span>
          </div>
        </div>

        <div class="relation-info-block" v-if="relationInfo.myRecommendedTarget">
          <div class="relation-info-label">推荐对象</div>
          <div class="relation-info-value relation-info-clickable"
            @click="goToRelationMemberDetail(relationInfo.myRecommendedTarget.memberId)">
            <span class="relation-member-name">{{ relationInfo.myRecommendedTarget.memberName || '--' }}</span>
            <span class="relation-member-serial">#{{ relationInfo.myRecommendedTarget.serialNumber || '--' }}</span>
          </div>
        </div>
      </div> -->

      <div class="detail-card dashboard-card">
        <div class="section-title">我的标签</div>

        <template v-if="personalityTags.length || spouseRequirementTags.length">
          <div class="tag-section" v-if="personalityTags.length">
            <div class="tag-section-label">我是这样的人</div>
            <div class="tag-section-content">
              <span v-for="(tag, index) in personalityTags" :key="'p-' + index" class="member-tag personality">{{
                tag.tagName }}</span>
            </div>
          </div>

          <div class="tag-section" v-if="spouseRequirementTags.length">
            <div class="tag-section-label">我想找这样的人</div>
            <div class="tag-section-content">
              <span v-for="(tag, index) in spouseRequirementTags" :key="'s-' + index" class="member-tag spouse">{{
                tag.tagName }}</span>
            </div>
          </div>
        </template>
        <div class="tag-empty" v-else>暂无标签</div>
      </div>

        <div class="detail-card info-card" v-if="hasSpouseRequirement">
          <div class="section-title">择偶要求</div>
          <div class="info-grid">
            <div class="info-cell"><span class="cell-label">出生年份</span><span class="cell-value">{{ spouseBirthYearText }}</span></div>
            <div class="info-cell"><span class="cell-label">身高范围</span><span class="cell-value">{{ spouseHeightText }}</span></div>
            <div class="info-cell"><span class="cell-label">学历</span><span class="cell-value">{{ spouseEducationText }}</span></div>
            <div class="info-cell"><span class="cell-label">期望结婚时间</span><span class="cell-value">{{ expectedMarriageDateText }}</span></div>
          </div>
        </div>

      <!-- <div class="detail-card info-card" v-show="role != 'Member'">
        <div class="section-title">跟进状态</div>
        <div class="desc-text">{{ followUpStatusText }}</div>
      </div> -->
      <div class="detail-card info-card">
        <div class="section-title">情感状态</div>
        <div class="desc-text">{{ emotionalStatusText }}</div>
        <!-- <div class="section-title">{{ followUpStatusText ? '跟进状态' : '情感状态' }}</div>
        <div class="desc-text">{{ followUpStatusText || emotionalStatusText }}</div> -->
      </div>

      <div class="detail-card declaration-card" v-if="memberInfos.datingDeclaration">
        <div class="section-title">交友宣言</div>
        <div class="declaration-text">{{ memberInfos.datingDeclaration }}</div>
      </div>
    </div>


      <div class="follow-up-page" v-if="role === 'Matchmaker'"
        style="margin:0 0.8rem 0.8rem;min-height:auto;padding-bottom:0;">
        <div class="section-card">
          <div class="section-title">心仪对象</div>
          <div class="action-row" @click="handleOpenFavoriteMembers">
            <div class="row-main">
              <div class="row-label">心仪对象</div>
              <div class="row-value multiline">查看</div>
            </div>
            <van-icon name="arrow" />
          </div>
        </div>
      
        <!-- 跟进情况：竖向时间线 -->
        <div class="section-card">
          <div class="section-title">跟进情况</div>
          <div class="follow-timeline" v-if="followUpList.length > 0">
            <div v-for="(item, idx) in followUpList" :key="idx" class="tl-item">
              <div class="tl-axis">
                <span class="tl-dot" :class="{ cancel: item.followUpStatus === 4 }"></span>
                <span class="tl-line" v-if="idx !== followUpList.length - 1"></span>
              </div>
              <div class="tl-card">
                <div class="tl-top">
                  <span class="tl-badge" :class="{ cancel: item.followUpStatus === 4 }">{{ getFollowUpStatusText(item.followUpStatus) }}</span>
                  <span class="tl-time">{{ getCompleteTime(item.createOn) }}</span>
                </div>
                <div class="tl-title">
                  {{ item.followUpStatus === 4 ? `${item.operatorName} 取消跟进` : `${item.matchmakerName} 申请跟进` }}
                </div>
                <div class="tl-desc" v-if="item.followUpStatus !== 4">
                  <span v-if="item.followUpDescription">具体情况：{{ item.followUpDescription }}</span>
                  <span v-if="item.theOtherHalfName" class="tl-link"
                    @click="goToTargetDetail(item.theOtherHalfMemberInfoId)">推荐对象：{{ item.theOtherHalfName }}
                    <van-icon name="arrow" size="0.8em" /></span>
                  <span v-if="item.theOtherHalfCompany">推荐对象单位：{{ item.theOtherHalfCompany }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="follow-empty">暂无跟进记录</div>
        </div>
      
        <!-- 操作按钮 -->
        <div class="follow-actions" v-if="role === 'Matchmaker'">
          <van-button round type="default" class="action-btn secondary" @click="contactMember">联系会员</van-button>
          <van-button round type="info" class="action-btn primary" @click="handleClaimFollowUp" v-if="canFlow">申请跟进</van-button>
          <van-button round type="info" class="action-btn primary" @click="handleOpenAddFollowUp" v-if="!canFlow">新增跟进</van-button>
          <van-button round type="default" class="action-btn secondary" @click="followUpCancal" v-if="!canFlow">取消跟进</van-button>
        </div>
      
        <!-- 新增跟进 popup -->
        <van-popup v-model="followUpStatusPicker" position="bottom" :style="{ height: '70%' }"
          :class="{ 'filed-checked': checkout }" safe-area-inset-bottom>
          <div class="followUp-pop">
            <div class="pop-header">新增跟进</div>
            <div class="pop-content">
              <!-- 步骤1: 推荐对象（选填） -->
              <div class="pop-section">
                <div class="pop-content-title">推荐对象<span class="pop-required">（必填）</span></div>
                <div class="pop-target-row" @click="handleSelectTargetMember">
                  <van-field :value="theOtherHalfDisplay || ''" placeholder="点击选择推荐对象" input-align="left"
                    readonly />
                  <van-icon name="arrow" />
                </div>
              </div>
              <!-- 步骤2: 跟进状态（必填） -->
              <div class="pop-section">
                <div class="pop-content-title">跟进状态<span class="pop-required">（必填）</span></div>
                <div class="pop-content-btn">
                  <van-button round type="info" @click="checkBtn(6)"
                    :class="{ 'pop-content-btnCheck': followUpStatus === 6 }">了解中</van-button>
                  <van-button round type="info" @click="checkBtn(7)"
                    :class="{ 'pop-content-btnCheck': followUpStatus === 7 }">交往中</van-button>
                  <van-button round type="info" @click="checkBtn(8)"
                    :class="{ 'pop-content-btnCheck': followUpStatus === 8 }">已订婚</van-button>
                  <van-button round type="info" @click="checkBtn(9)"
                    :class="{ 'pop-content-btnCheck': followUpStatus === 9 }">已领证</van-button>
                </div>
              </div>
              <!-- 步骤3: 具体情况（必填） -->
              <div class="pop-section">
                <div class="pop-content-title">具体情况填写<span class="pop-required">（必填）</span></div>
                <van-field v-model="message" rows="2" autosize type="textarea" @focus="focusFiled" @blur="blurFiled" />
              </div>
            </div>
            <div class="pop-footer">
              <van-button round type="info" class="pop-footer-cancal" @click="handleCancel">取消</van-button>
              <van-button round type="info" class="pop-footer-success" @click="handleAddFollowUp">确认</van-button>
            </div>
          </div>
        </van-popup>
      </div>

      <div class="detail-footer" v-if="role === 'Member'">
        <van-button round plain class="action-btn favorite-action" @click="toggleFavorite" :loading="favoriteLoading">
          <van-icon :name="isFavorited ? 'like' : 'like-o'" size="1rem" />
          <span>{{ isFavorited ? '已收藏' : '收藏' }}</span>
        </van-button>
        <van-button round type="primary" class="action-btn primary" @click="handleMembersInfo">联系红娘</van-button>
      </div>
  </div>
</template>
<script>
import { getInfo, getMatchmakerViewMemberInfo, createBrowsingHistory } from "../api/user";
import { mapGetters, mapActions } from "vuex";
import defaultBg from "../assets/defaultBg.png";
import womanPhoto from "../assets/icon_female@2x.png";
import manPhoto from "../assets/icon_male@2x.png";
import defaultPhoto from "../assets/defaultPhoto.png";
import { Toast, ImagePreview } from "vant";
import { getMatchmakerInfo, getFollowUpProgressListByMemberId, postFollowUpMembers, cancelFollowUpMembers, getFollowUpRelationshipByMemberId } from '../api/matchmakerInfo';
import { addFavorite, removeFavorite, isFavorite } from '../api/memberFavorite';

export default {
  data() {
    return {
      canFlow: true,
      followUpStatusPicker: false,
      checkout: false,
      followUpStatus: 0,
      message: '',
      showMoreInfo: false,
      memberInfos: {
        serialNumber: "",
        birthday: "",
        height: "",
        hometown: "",
        education: "",
        tikTok: "",
        personalPhotos: [],
        theOtherHalfMemberInfoId: '',
        theOtherHalfName: '',
        theOtherHalfSerialNumber: '',
        theOtherHalfCompany: '',
      },
      userInfo: {},
      personalityTags: [],
      spouseRequirementTags: [],
      relationInfo: null,
        followUpList: [],
      manPhoto,
      womanPhoto,
      defaultPhoto,
      current: 0,
        isFavorited: false,
        favoriteLoading: false,
      educationData: ["大专", "本科", "硕士", "博士", "高中及以下"],
      spouseEducationData: ["大专及以上", "本科及以上", "硕士及以上", "博士及以上"], // 择偶学历显示数组
      checkboxData: [
        "球类运动（篮球、兵乓球、羽毛球等）",
        "体育运动（跑步、跳绳、健身等）",
        "户外活动（旅游、登山）",
        "文艺类（唱歌、跳舞、乐器）",
        "娱乐类（逛街、看电影、看书）",
        "冒险类（潜水，攀岩）",
        "智力类（拼图、拆装）",
        "游戏类（桌游、网游）",
        "休闲类（园艺、写生、摄影）",
        "美食类（火锅、烧烤等）",
        "烹饪类（中餐、西餐、糕点）",
        "其他"
      ],
      statusData: ["启动", "过程", "结果", "取消跟进", "互加微信", "了解中", "交往中", "已订婚", "已领证", "跟进"],
      maritalStatusData: ["未婚", "离异/无子女", "离异有子女", "其他"],
      personalBeliefsData: ["基督教", "天主教", "佛教", "伊斯兰教", "无", "其它"],
      housingData: ["自己有住房", "已购房", "计划购房", "无计划"]
    };
  },
  computed: {
    ...mapGetters(["role"]),
    hasSpouseRequirement() {
      return !!(this.memberInfos.spouseBirthYearMin || this.memberInfos.spouseBirthYearMax ||
        this.memberInfos.spouseHeightMin || this.memberInfos.spouseHeightMax ||
        this.memberInfos.spouseEducation ||
        this.memberInfos.expectedMarriageDate);
    },
    spouseBirthYearText() {
      const min = this.memberInfos.spouseBirthYearMin;
      const max = this.memberInfos.spouseBirthYearMax;
      if (min && max) return `${min}年-${max}年`;
      if (min) return `${min}年以后`;
      if (max) return `${max}年以前`;
      return '--';
    },
    spouseHeightText() {
      const min = this.memberInfos.spouseHeightMin;
      const max = this.memberInfos.spouseHeightMax;
      if (min && max) return `${min}CM-${max}CM`;
      if (min) return `${min}CM以上`;
      if (max) return `${max}CM以下`;
      return '--';
    },
    expectedMarriageDateText() {
      const v = this.memberInfos.expectedMarriageDate;
      if (!v) return "--";
      const d = new Date(String(v).replace(/Z$/, "").replace(/\+00:00$/, ""));
      if (isNaN(d.getTime())) return "--";
      const y = d.getFullYear();
      const m2 = String(d.getMonth() + 1).padStart(2, "0");
      return `${y}-${m2}`;
    },
    spouseEducationText() {
      const v = this.memberInfos.spouseEducation;
      if (v === null || v === undefined || v === "") return "--";
      const map = { 0: "不限", 1: "大专及以上", 2: "本科及以上", 3: "硕士及以上", 4: "博士及以上" };
      return map[v] || "--";
    },
    theOtherHalfDisplay() {
      const sn = this.memberInfos.theOtherHalfSerialNumber;
      const name = this.memberInfos.theOtherHalfName;
      if (sn && name) return `#${sn} ${name}`;
      if (sn) return `#${sn}`;
      if (name) return name;
      return "";
    },
    educationText() {
      return this.memberInfos.education ? this.educationData[this.memberInfos.education - 1] : "";
    },
    sexText() {
      if (!this.memberInfos.sex) return "";
      return this.memberInfos.sex === 1 ? "男" : "女";
    },
    interestTexts() {
      const interests = this.memberInfos.descriptionOfPersonalInterests || [];
      return interests
        .map(item => Number(item))
        .filter(Boolean)
        .map(item => this.checkboxData[item - 1])
        .filter(Boolean);
    },
    followUpText() {
      if (this.memberInfos.followUpStatus && this.statusData[this.memberInfos.followUpStatus - 1]) {
        return `${this.statusData[this.memberInfos.followUpStatus - 1]}: ${this.memberInfos.followUpDescription || ""}`;
      }
      return "";
    },
    followUpStatusText() {
      return this.followUpText;
    },
    emotionalStatusText() {
      const statusMap = {
        1: "单身ing",
        // 2: "暗恋中",
        // 3: "暧昧中",
        4: "恋爱ing",
        // 5: "订婚",
        6: "已结婚",
        // 7: "其他"
      };
      const status = this.memberInfos.emotionalStatus;
      return statusMap[status] || "未设置";
    },
    maritalStatusText() {
      return this.memberInfos.maritalStatus ? this.maritalStatusData[this.memberInfos.maritalStatus - 1] : "";
    },
    beliefsText() {
      return this.memberInfos.personalBeliefs ? this.personalBeliefsData[this.memberInfos.personalBeliefs - 1] : "";
    },
    housingText() {
      return this.memberInfos.housingSituation ? this.housingData[this.memberInfos.housingSituation - 1] : "";
    },
      memberSummary() {
                return this.memberInfos.aiSummary || '';
            },
    followUpSummary() {
      const { followUpStatus, followUpDescription } = this.memberInfos;
      if (followUpStatus && this.statusData[followUpStatus - 1]) {
        return `${this.statusData[followUpStatus - 1]}：${followUpDescription || ''}`;
      }
      return '暂无跟进情况';
    },
  },
  methods: {
    ...mapActions(["GetInfo", "CreateConversation", "SendMessage", "SetCurrentConversation"]),
      // 检查收藏状态
      async checkFavoriteStatus() {
        if (this.role !== "Member" || !this.$store.getters.baseInfo || !this.$store.getters.baseInfo.id) return;
        try {
          const res = await isFavorite(this.$store.getters.baseInfo.id, this.$route.params.id);
          if (res.code === 20000) {
            this.isFavorited = !!res.data;
          }
        } catch (e) { /* ignore */ }
      },
      async toggleFavorite() {
        if (this.favoriteLoading) return;
        if (this.role !== "Member") return;
        const baseInfo = this.$store.getters.baseInfo;
        if (!baseInfo || !baseInfo.id) return;
        this.favoriteLoading = true;
        try {
          const memberId = baseInfo.id;
          const favoriteMemberId = this.$route.params.id;
          if (this.isFavorited) {
            const res = await removeFavorite(memberId, favoriteMemberId);
            if (res.code === 20000) {
              this.isFavorited = false;
              Toast.success("已取消收藏");
            } else {
              Toast.fail(res.msg || "操作失败");
            }
          } else {
            const res = await addFavorite(memberId, favoriteMemberId);
            if (res.code === 20000) {
              this.isFavorited = true;
              Toast.success("已收藏到心仪对象");
            } else {
              Toast.fail(res.msg || "收藏失败");
            }
          }
        } catch (e) {
          Toast.fail("操作失败");
        } finally {
          this.favoriteLoading = false;
        }
      },
    formatSerial(serialNumber) {
      if (!serialNumber) return "0000";
      return String(serialNumber).padStart(4, "0");
    },
    normalizeMemberData(data) {
      this.memberInfos = data || {};
      this.personalityTags = data.personalityTags || [];
      this.spouseRequirementTags = data.spouseRequirementTags || [];
        // AI总结已改为后端注册/修改时回写AISummary字段，前端直接取值
      const interests = data.descriptionOfPersonalInterests;
      const interestArray = Array.isArray(interests)
        ? interests
        : typeof interests === "string" && interests
          ? interests.split(",")
          : [];
      this.$set(this.memberInfos, "descriptionOfPersonalInterests", interestArray);
      if (!data.personalPhotos || data.personalPhotos.length === 0){// || data.showAvatar === 2 || data.showAvatar === 0) {
        this.$set(this.memberInfos, "personalPhotos", [{ url: defaultBg }]);
      }
      // 检查推荐对象选择回传数据（followUpTargetSelector 通过 go(-1) 返回）
      // 必须在 this.memberInfos = data 覆盖之后执行，否则会被后端数据覆盖
      if (window._targetMemberSelected) {
        this.handleTargetMemberSelected(window._targetMemberSelected);
      this.followUpStatusPicker = true; // 选完推荐对象回来自动打开新增跟进弹窗
        delete window._targetMemberSelected;
      }
      this.initMatchmakerViewMemberInfo();
        this.checkFavoriteStatus();
    },
      // fetchAiSummary 已移除：AI总结改为后端注册/修改时生成并回写AISummary字段
      handleMembersInfo() {
      if (this.role === "Member") {
        if (!this.memberInfos.matchmakerInfoId) {
          Toast.fail({ message: "无红娘，请联系管理员18859389611" });
        } else {
          this.contactMatchmaker();
        }
      } else {
        this.$router.push({ path: `/followUpPage/${this.$route.params.id}` });
      }
    },
    async contactMatchmaker() {
      try {
        Toast.loading({ message: "正在打开聊天...", forbidClick: true });
        const matchmakerRes = await getMatchmakerInfo({ id: this.memberInfos.matchmakerInfoId });
        if (matchmakerRes.code !== 20000) {
          Toast.fail("获取红娘信息失败");
          return;
        }
        const matchmakerInfo = matchmakerRes.data;
        await this.GetInfo();
        const memberInfo = this.$store.getters.baseInfo;
        const initialMessage = `你好，我是会员${memberInfo.nickName || "编号" + (memberInfo.serialNumber || "")},我想了解【会员】-${this.memberInfos.serialNumber} - ${this.memberInfos.nickName || "编号" + this.memberInfos.serialNumber}，请帮忙介绍！`;
        const guestCardPayload = {
          memberId: this.memberInfos.id || this.$route.params.id,
          serialNumber: this.memberInfos.serialNumber,
          name: this.memberInfos.nickName || '',
        nickName: this.memberInfos.nickName || '',
          avatarLink: this.memberInfos.avatarLink,
          sex: this.memberInfos.sex,
          birthday: this.memberInfos.birthday,
          height: this.memberInfos.height,
          education: this.memberInfos.education,
          hometown: this.memberInfos.hometown
        };
        const conversationRes = await this.CreateConversation({
          matchmakerId: this.memberInfos.matchmakerInfoId,
          targetUserId: this.memberInfos.matchmakerInfoId,
          targetUserType: "Matchmaker"
        });
        await this.SendMessage({
          conversationId: conversationRes.id,
          content: initialMessage,
          messageType: 1
        });
        await this.SendMessage({
          conversationId: conversationRes.id,
          content: `[嘉宾卡片] ${this.memberInfos.serialNumber || ""} ${this.memberInfos.nickName || ""}`.trim(),
          messageType: 3,
          payloadJson: JSON.stringify(guestCardPayload)
        });
        Toast.clear();
        await this.SetCurrentConversation(conversationRes);
        this.$router.push({
          path: `/chatRoom/${conversationRes.id}`,
          query: {
            matchmakerId: this.memberInfos.matchmakerInfoId,
            memberId: memberInfo.id,
            matchmakerName: matchmakerInfo.name,
              memberName: memberInfo.nickName || ("会员" + (memberInfo.serialNumber || "")),
            matchmakerAvatar: matchmakerInfo.avatarLink,
            memberAvatar: memberInfo.avatarLink
          }
        });
      } catch (error) {
        Toast.clear();
        console.error("联系红娘失败:", error);
        Toast.fail("联系红娘失败，请联系管理员18859389611");
      }
    },
    onClickLeft() {
      const storedRoute = sessionStorage.getItem('firstEntryRoute');
      if (storedRoute) {
        const routerHistory = this.$router.history;
        const currentIndex = routerHistory.current && routerHistory.stack ? routerHistory.stack.findIndex(item => item.fullPath === routerHistory.current.fullPath) : -1;
        if (currentIndex > 0) {
          const previousRoute = routerHistory.stack[currentIndex - 1];
          if (previousRoute && previousRoute.name === 'detailInformation') {
            this.$router.go(-1);
            return;
          }
        }
        const firstEntryRoute = JSON.parse(storedRoute);
        sessionStorage.removeItem('firstEntryRoute');
        this.$router.replace(firstEntryRoute);
      } else {
        this.$router.go(-1);
      }
    },
    swipeOnChange(index) {
      this.current = index;
    },
    previewAvatar() {
      if (this.memberInfos.avatarLink) {
        ImagePreview({
          images: [this.memberInfos.avatarLink],
          closeable: true,
          closeIconPosition: "top-right"
        });
      }
    },
    previewPhoto(index) {
      const images = (this.memberInfos.personalPhotos || []).map(item => item.url);
      ImagePreview({
        images: images,
        startPosition: index,
        closeable: true,
        closeIconPosition: "top-right"
      });
    },
    goToRelationMemberDetail(memberId) {
      if (!memberId) return;
      this.$router.push({ path: `/detailInformation/${memberId}` });
    },
    loadMemberData(memberId) {
      //console.log(memberId);
      // 重置关联数据
      this.relationInfo = null;
      // 加载会员基本信息
      if (this.role === "Member") {
        getInfo(memberId).then(res => {
          if (res.code === 20000) {
            this.normalizeMemberData(res.data);
          }
        });
      } else {
        getMatchmakerViewMemberInfo(memberId).then(res => {
          if (res.code === 20000) {
            this.userInfo = JSON.parse(JSON.stringify(res.data));
            this.normalizeMemberData(res.data);
          }
        });
      }
      // 获取跟进关联信息
      getFollowUpRelationshipByMemberId({ memberInfoId: memberId }).then(res => {
        if (res.code === 20000 && res.data) {
          this.relationInfo = res.data;
        }
      });

      const data = {
        baseMemberInfoId: this.$store.getters.baseInfo.id,
        browsedMemberInfoId: memberId,
        browseTime: new Date().toISOString(),
      };
      createBrowsingHistory(data);
    },
    handleTargetMemberSelected(payload) {
      if (!payload) return;
      this.memberInfos.theOtherHalfMemberInfoId = payload.targetMemberId;
      this.memberInfos.theOtherHalfName = payload.targetMemberNickName || "";
      this.memberInfos.theOtherHalfSerialNumber = payload.targetMemberSerialNumber || "";
      this.memberInfos.theOtherHalfCompany = payload.targetMemberCompany || "";
      window.scrollTo(0, document.body.scrollHeight);
    },
    handleSelectTargetMember() {
      this.$router.push({
        path: `/followUpTargetSelector/${this.$route.params.id}`,
        query: {
          currentMemberSex: this.memberInfos.sex
        }
      });
    },
    handleCilckFollowUp() {
      if (this.memberInfos.followUpRecords !== '暂无跟进记录') {
        this.$router.push({ path: `/followUpRecords/${this.$route.params.id}` });
      }
    },
    handleOpenFavoriteMembers() {
      this.$router.push({
        path: '/myFavoriteMembers',
        query: {
          memberId: this.$route.params.id,
            memberName: this.memberInfos.nickName || '',
          readonly: '1',
          source: 'followUp'
        }
      });
    },
    async contactMember() {
      if (!this.validateFollowUpOwnership()) {
        return;
      }
      try {
        Toast.loading({ message: '正在打开聊天...', forbidClick: true });
        const baseInfo = this.$store.getters.baseInfo || {};
        const conversationRes = await this.CreateConversation({
          targetUserId: this.memberInfos.id || this.$route.params.id,
          targetUserType: 'Member'
        });
        Toast.clear();
        await this.SetCurrentConversation(conversationRes);
        this.$router.push({
          path: `/chatRoom/${conversationRes.id}`,
          query: {
            matchmakerId: baseInfo.id,
            memberId: this.memberInfos.id || this.$route.params.id,
            matchmakerName: baseInfo.name,
              memberName: this.memberInfos.nickName || ("会员" + (this.memberInfos.serialNumber || "")),
            matchmakerAvatar: baseInfo.avatarLink,
            memberAvatar: this.memberInfos.avatarLink
          }
        });
      } catch (error) {
        Toast.clear();
        console.error('联系会员失败:', error);
        Toast.fail('联系会员失败，请重试');
      }
    },
    followUpCancal() {
      const data = this.userInfo;
      if (!this.validateFollowUpOwnership('不能取消其他红娘的跟进')) {
        return;
      }
      const params = {
        memberInfoId: data.id,
        matchmakerId: this.$store.getters.baseInfo.id
      };
      cancelFollowUpMembers(params).then(res => {
        if (res.code === 20000) {
          Toast.success({ message: '取消跟进成功' });
          this.initMatchmakerViewMemberInfo();
        this.checkFavoriteStatus();
          //this.$router.go(-1);
        }
      });
    },
    followUpOk(noGoToBack, skipValidation) {
      if (!skipValidation && !this.validateFollowUpForm()) {
        return;
      }
      const params = {
        memberInfoId: this.$route.params.id,
        theOtherHalfName: this.memberInfos.theOtherHalfName,
        theOtherHalfCompany: this.memberInfos.theOtherHalfCompany,
        theOtherHalfMemberInfoId: this.memberInfos.theOtherHalfMemberInfoId,
        theOtherHalfSerialNumber: this.memberInfos.theOtherHalfSerialNumber,
        followUpStatus: this.memberInfos.followUpStatus,
        followUpDescription: this.memberInfos.followUpDescription,
        matchmakerId: this.$store.getters.baseInfo.id
      };
      postFollowUpMembers(params).then(res => {
        if (res.code === 20000) {
          Toast.success({ message: this.memberInfos.followUpStatus === 10 ? '跟进成功' : '跟进记录已保存' });
          // 新增跟进/申请跟进操作成功后统一刷新数据（时间线+跟进关系+按钮状态）
          this.initMatchmakerViewMemberInfo();
          this.checkFavoriteStatus();
        }
      });
    },
    initMatchmakerViewMemberInfo() {

      const {
        targetMemberId,
        targetMemberName,
        targetMemberSerialNumber,
        targetMemberCompany
      } = this.$route.query;
      if (targetMemberId) {
        this.memberInfos.theOtherHalfMemberInfoId = targetMemberId;
        this.memberInfos.theOtherHalfSerialNumber = targetMemberSerialNumber || '';
        this.memberInfos.theOtherHalfCompany = targetMemberCompany || '';
        window.scrollTo(0, document.body.scrollHeight);
      }

      const params = {
        memberInfoId: this.$route.params.id
      };
        getFollowUpProgressListByMemberId(params).then(item => {
          this.canFlow = true;
          if (item.data) {
            this.followUpList = item.data;
            if (item.data.length > 0) {
              let obj = item.data[0];
              this.canFlow = obj.matchmakerInfoId != this.$store.getters.baseInfo.id
            }
          }
        });
      getFollowUpRelationshipByMemberId({ memberInfoId: this.$route.params.id }).then(res => {
        if (res.code === 20000 && res.data) {
          this.relationInfo = res.data;
        }
      });
      // getMatchmakerViewMemberInfo(this.$route.params.id).then(res => {
      //   if (res.data) {
      //     let data = JSON.parse(JSON.stringify(res.data));
      //     this.userInfo = JSON.parse(JSON.stringify(res.data));
      //     data.personalPhotos = data.personalPhotos || [];
      //     data.personalityTags = data.personalityTags || [];
      //     data.spouseRequirementTags = data.spouseRequirementTags || [];
      //     data.descriptionOfSpouseSelectionRequirements = data.descriptionOfSpouseSelectionRequirements || '';
      //     data.personalCharacterDescription = data.personalCharacterDescription || '';
      //     if (data.descriptionOfPersonalInterests) {
      //       data.descriptionOfPersonalInterests = data.descriptionOfPersonalInterests.split(',');
      //     }
      //     const params = {
      //       memberInfoId: this.$route.params.id
      //     };
      //     var memberInfos = data;
      //     const baseInfo = this.$store.getters.baseInfo;
      //     if (memberInfos.matchmakerInfoId && baseInfo.id !== memberInfos.matchmakerInfoId) {
      //       this.hasOtherMatchmaker = true;
      //     }
      //     const {
      //       targetMemberId,
      //       targetMemberName,
      //       targetMemberSerialNumber,
      //       targetMemberCompany
      //     } = this.$route.query;
      //     if (targetMemberId) {
      //       this.memberInfos.theOtherHalfMemberInfoId = targetMemberId;
      //       this.memberInfos.theOtherHalfName = targetMemberName || memberInfos.theOtherHalfName;
      //       this.memberInfos.theOtherHalfSerialNumber = targetMemberSerialNumber || '';
      //       this.memberInfos.theOtherHalfCompany = targetMemberCompany || '';
      //     }
      //     const params = {
      //       memberInfoId: this.$route.params.id
      //     };
      //     getFollowUpProgressListByMemberId(params).then(item => {
      //       this.canFlow = true;
      //       if (item.data) {
      //         if (item.data.length > 0) {
      //           let obj = item.data[0];
      //           this.canFlow = obj.matchmakerInfoId != this.$store.getters.baseInfo.id
      //           let followUpRecords = '';
      //           if (obj.followUpStatus === 4) {
      //             followUpRecords = this.getCompleteTime(obj.createOn) + '由' + obj.operatorName + '取消跟进';
      //           } else {
      //             followUpRecords = this.getCompleteTime(obj.createOn) + '由' + obj.matchmakerName + '申请跟进';
      //           }
      //           this.$set(this.memberInfos, 'followUpRecords', followUpRecords);
      //         } else {
      //           this.$set(this.memberInfos, 'followUpRecords', '暂无跟进记录');
      //         }
      //       }
      //     });
      //     getFollowUpRelationshipByMemberId({ memberInfoId: this.$route.params.id }).then(res => {
      //       if (res.code === 20000 && res.data) {
      //         this.relationInfo = res.data;
      //       }
      //     });
      //   }
      // });
    },
      // 需求一：申请跟进 = 一键认领，无需填写任何信息
      handleClaimFollowUp() {
        // 按需求：已有其他红娘跟进时不再前端拦截，继续调用接口（后端负责通知）
        this.$dialog.confirm({
          title: '申请跟进',
          message: '确认认领该会员并建立跟进关系？',
          confirmButtonText: '一键跟进',
        }).then(() => {
          this.memberInfos.followUpStatus = 10;
          // 一键认领无需填写，默认描述供记录展示
         this.memberInfos.followUpDescription = '申请跟进';
          this.memberInfos.theOtherHalfMemberInfoId = '';
          this.memberInfos.theOtherHalfName = '';
          this.memberInfos.theOtherHalfSerialNumber = '';
          this.memberInfos.theOtherHalfCompany = '';
          this.followUpOk(true, true);
        }).catch(() => {});
      },
      
      handleOpenAddFollowUp() {
        // 需求二：新增跟进 = 记录完整推荐进度，仅限该会员的跟进红娘
        if (this.canFlow) {
          this.$dialog.alert({
            title: '提示',
            message: '请先申请跟进该会员',
            confirmButtonText: '知道了',
          });
          return;
        }
        this.followUpStatusPicker = true;
        this.message = '';
        this.followUpStatus = 0;
          // 保留已选推荐对象（选择回来后不丢失），只重置状态和具体情况
      },
    toDetail() {
      if (this.memberInfos.theOtherHalfMemberInfoId) {
        this.$router.push({ path: `/detailInformation/${this.memberInfos.theOtherHalfMemberInfoId}` });
      }
    },
      handleAddFollowUp() {
        this.memberInfos.followUpDescription = this.message;
        this.memberInfos.followUpStatus = this.followUpStatus;
        if (!this.validateFollowUpForm()) {
          return;
        }
        this.followUpStatusPicker = false;
        this.followUpOk(true);
      },
    handleCancel() {
      this.message = this.memberInfos.followUpDescription;
      this.followUpStatus = this.memberInfos.followUpStatus;
      this.followUpStatusPicker = false;
    },
      validateFollowUpForm() {
        if (!this.memberInfos.theOtherHalfMemberInfoId) {
          Toast.fail({ message: '请选择推荐对象' });
          return false;
        }
        if (!this.memberInfos.followUpStatus) {
          Toast.fail({ message: '请选择跟进状态' });
          return false;
        }
        if (!this.memberInfos.followUpDescription) {
          Toast.fail({ message: '请输入具体情况' });
          return false;
        }
        return true;
      },
    focusFiled() {
      if (navigator.userAgent) {
        let isHuawei = navigator.userAgent.toLowerCase().match(/huawei/i) === 'huawei';
        if (isHuawei) {
          this.checkout = true;
        }
      }
    },
    blurFiled() {
      this.checkout = false;
    },
      checkBtn(num) {
        this.followUpStatus = num;
      },
      
      getFollowUpStatusText(status) {
        if (status === 4) return '取消';
        return this.statusData[status - 1] || '跟进';
      },
      goToTargetDetail(memberInfoId) {
        if (memberInfoId) {
          this.$router.push({ path: `/detailInformation/${memberInfoId}` });
        }
      },

    validateFollowUpOwnership(cancelMessage = '当前会员已有其他红娘跟进') {
      const baseInfo = this.$store.getters.baseInfo;
      if (this.memberInfos.matchmakerInfoId && baseInfo.id !== this.memberInfos.matchmakerInfoId) {
        Toast.fail({ message: cancelMessage });
        return false;
      }
      return true;
    },
  },
  watch: {
    '$route.params.id'(newId) {
      if (newId) {
        this.loadMemberData(newId);
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const storedRoute = sessionStorage.getItem('firstEntryRoute');
      console.log('storedRoute', storedRoute);
      if (!storedRoute && from.path && from.path !== '/' && from.name !== 'detailInformation') {
        const routeData = { path: from.path, name: from.name, query: from.query, params: from.params };
        sessionStorage.setItem('firstEntryRoute', JSON.stringify(routeData));
      }
    });
  },
  created() {
    this.loadMemberData(this.$route.params.id);
  },
  // beforeRouteEnter(to, from, next) {
  //   switch (from.name) {
  //     case 'detailInformation':
  //     case 'followUpTargetSelector':
  //     case 'followUpTargetSelector':
  //       break;
  //   }
  //   next();
  // },
};
</script>
<style lang="less" src="../style/detailInformation.less" />
<style lang="less" src="../style/followUpPage.less" />


// WEBPACK FOOTER //
// src/views/detailInformation.vue